// Detect user's preferred language from browser
export function detectLocale() {
  const raw = navigator.language || navigator.userLanguage || "en";

  // Normalize: en-US → en
  return raw.split("-")[0];
}
